
/**
 * getEnvironment - Returns the current environment, or development by default
 * @returns {String}
 */
export const getEnvironment = () => process.env.NODE_ENV
  ? process.env.NODE_ENV
  : 'development';


/**
 * getApiUrl  - Returns the URL for the api, given the current environment
 * @returns {String}
 */
export const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api`;
  }
  return '/api';
};


/**
 * getAppUrl  - Returns the URL for the app, given the environment
 * @returns {String}
 */
export const getAppUrl = () => {
  switch (getEnvironment()) {
    case 'production':
      return typeof window !== 'undefined' ? window.location.origin : '';
    case 'stage':
      return 'http://app-stage.mkrn-stage-domain.com';
    case 'test':
      return 'http://app-test.mkrn-test-domain.com';
    case 'development':
    default:
      return 'http://localhost:8080';
  }
};
